/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, OnDestroy } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '../app.reducers';

import { ReferralRewards } from '@shared/models/Profile';

@Component({
    selector: 'app-register-friend',
    templateUrl: './register-friend.component.html',
    styleUrls: ['./register-friend.component.scss'],
    standalone: false
})
export class RegisterFriendComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  rewards: ReferralRewards;

  constructor(private store: Store) {
    this.store.pipe(select(fromAppRoot.selectReferralRewards), takeUntil(this.onDestroy$)).subscribe((response: ReferralRewards) => {
      if (response?.referrer_name?.length === 0) {
        return;
      }

      this.rewards = response;
    });
  }

  moneyRewards(): boolean {
    return this.rewards?.referral_rewards?.money?.money_monthly > 0;
  }

  getRewardsAmount(): number {
    if (this.moneyRewards()) {
      const moneyObj = this.rewards?.referral_rewards?.money;
      return moneyObj.money_monthly * moneyObj.months_duration;
    }
    return this.rewards?.referral_rewards?.months;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
